import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { servicedeskProformaIssueFormsDirectRoute } from '@atlassian/jira-router-routes-proforma-routes/src/servicedeskProformaIssueFormsDirectRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { proformaIssueFormsDirectPageEntryPoint } from './ui/issue-forms-direct/index.tsx';

export const servicedeskProformaIssueFormsDirectRouteEntry = createEntry(
	servicedeskProformaIssueFormsDirectRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		resources: [...jiraSpaResources(), projectContextResource],

		navigation: {
			menuId: MENU_ID.PROJECTS,
		},

		entryPoint: () => proformaIssueFormsDirectPageEntryPoint,
		perfMetricKey: 'issue-forms-direct',

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-proforma-entries/src/servicedeskProformaIssueFormsDirectRouteEntry.tsx',
				whichExportToUse: 'servicedeskProformaIssueFormsDirectRouteEntry',
			},

			enabled: true,
		},
	}),
);
